import { Tooltip, Typography } from "@mui/material"
import type { TypographyProps } from "@mui/material"

import useIsCut from "helpers/hooks/useIsCut"

/**
 * One line of text, cut with an ellipsis when it does not fit, and then shown in full
 * in a tooltip. Inherits the surrounding font unless given a variant.
 */
const TruncatedText = ({ children, variant = "inherit", ...props }: TypographyProps) => {
  const { ref, isCut } = useIsCut<HTMLSpanElement>(children)

  return (
    // describeChild, or the empty title would become the text's aria-label.
    <Tooltip title={isCut ? children : ""} describeChild>
      <Typography
        {...props}
        ref={ref}
        component="span"
        variant={variant}
        display="block"
        minWidth={0}
        noWrap
      >
        {children}
      </Typography>
    </Tooltip>
  )
}

export default TruncatedText
